import React, { memo, useEffect } from 'react';
import { Box, Flex, Spinner } from '@televet/kibble-ui';

const QuicksightReportIFrame = (): JSX.Element => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  console.log('Rendering QuicksightReportIFrame');
  const quickSightContainer = window.quickSightContainer;
  useEffect(() => {
    if (quickSightContainer) {
      containerRef?.current?.replaceWith(quickSightContainer);
    }
    return (): void => {
      window.quickSightContainer.innerHTML = '';
    };
  }, [quickSightContainer]);

  return (
    <Flex justifyContent="center" alignItems="center" height="100%">
      <Box position="absolute" zIndex="0">
        <Spinner size="xl" />
      </Box>
      <div ref={containerRef} />
    </Flex>
  );
};

// Memoize the component to prevent re-rendering since each render would count as a new session in QuickSight
// once the iframe is rendered we want to use NavigateToDashboard to change the dashboard
export default memo(QuicksightReportIFrame);
